import { Validators } from '@angular/forms';
import { Injector, Component } from '@angular/core';

import { ICourseModel, ClubConfirmationMethod } from 'app/common/models/course.model';
import { NotEmpty } from 'app/common/validators/required-not-empty.validator';
import { ICoachModel } from 'app/common/models/coach.model';
import { CoachesService } from 'app/components/coaches/services/coaches.service';
import { IClubroomModel } from 'app/common/models/clubroom.model';
import { ClubroomsService } from 'app/components/clubrooms/services/clubrooms.service';
import { ITrainingCategory } from 'app/common/models/training-category.model';
import { EditItemComponent } from 'app/common/edit-item.component';
import { EntityStatus } from 'app/common/models/entity-status.model';
import { ApiService } from 'app/common/services/api.service';
import { CoursesService } from 'app/components/courses/services/courses.service';
import { MediaService } from 'app/common/services/media.service';
import { SubscriptionService } from 'app/components/subscriptions/services/subscription.service';
import { IIdName } from 'app/common/models/id-name.model';
import { ISubscription } from 'app/common/models/subscription.model';
import { ClubSettingService } from 'app/components/club-settings/club-settings.service';
import { ClubSetting } from 'app/common/models/club-setting.model';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-course-edit',
  templateUrl: './course-edit.component.html',
  styleUrls: ['./course-edit.component.scss'],
  animations: [
    trigger('animation', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('0.2s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('0.2s', style({ opacity: 0 }))
      ])
    ])
  ],
})

export class CourseEditComponent extends EditItemComponent<ICourseModel> {
  public static readonly componentName: string = 'CourseEditComponent';
  initPlans: IIdName[];
  public clubPlans: Array<ISubscription> = [];
  public clubCoaches: Array<ICoachModel> = [];
  public clubRooms: Array<IClubroomModel> = [];
  public trainingCategories: Array<ITrainingCategory> = [];
  public subscriptionPlans: any[];
  public clubSettings: ClubSetting[];
  public showAdditionalSettings: boolean = false;

  public isClubAllowedAutoMissing: boolean = false;

  fieldMessages = {
    name: {
      NotEmpty: 'Это поле обязательно'
    },
    color: {
      required: 'Необходимо указать цвет'
    }
  };

  photoValidationOptions = {
    formats: ['jpg', 'jpeg', 'png'],
    aspectRatio: { ratio: { width: 16, height: 9 }, tolerance: 0.05 },
    resolution: { width: 1920, height: 1080 },
    maxSize: 10 * 1024 * 1024,
  };

  infoTooltip = `Формат: ${this.photoValidationOptions.formats}\nМаксимальный размер: ${this.photoValidationOptions.maxSize / 1024 / 1024} Мб`

   isShowCoaches() {
    return this.Model.coaches && this.Model.coaches.length > 0;
  }

  constructor(
    injector: Injector,
    protected mediaService: MediaService,
    protected service: CoursesService,
    protected coachService: CoachesService,
    protected clubRoomService: ClubroomsService,
    protected subscriptionsPlansService: SubscriptionService,
    protected clubSettingService: ClubSettingService,
    private apiService: ApiService
  ) {
    super(injector, service);
  }

  toggleShowAdditionalSettings() {
    this.showAdditionalSettings = !this.showAdditionalSettings;
  }

  ngOnInit(){
    super.ngOnInit();

    this.subscriptionsPlansService.getItemList()
    .then(plans =>
      this.clubPlans = plans

    );

    this.coachService.getItemList()
    .then(coaches => this.clubCoaches = coaches);

    this.clubRoomService.getItemList()
      .then(clubrooms => this.clubRooms = clubrooms);

    this.apiService.trainingCategories.getList()
      .then(categories => this.trainingCategories = categories);

    this.clubSettingService.getClubSettingsByClub()
      .then(settings => {
        this.clubSettings = settings;
        let isAutoMissing = this.clubSettings.find(e => e.alias == "IsAutoMissing");
        this.isClubAllowedAutoMissing = (isAutoMissing.value == "true");
      });
  }

  modelTemplate(): Promise<ICourseModel> {
    const template: ICourseModel = {
      name: null,
      group: null,
      sortOrder: null,
      description: null,
      shortDescription: null,
      isPopular: false,
      color: '#c0c0c0',
      entityStatus: EntityStatus.draft,
      imageUrl: '',
      id: null,
      trainingCategories: [],
      workingTime: {
        mon: { 'hourFrom': '00:00', 'hourTo': '23:59' },
        tue: { 'hourFrom': '00:00', 'hourTo': '23:59' },
        wed: { 'hourFrom': '00:00', 'hourTo': '23:59' },
        thu: { 'hourFrom': '00:00', 'hourTo': '23:59' },
        fri: { 'hourFrom': '00:00', 'hourTo': '23:59' },
        sat: { 'hourFrom': '00:00', 'hourTo': '23:59' },
        sun: { 'hourFrom': '00:00', 'hourTo': '23:59' },
      },
      isVoluntaryBookingAllowed: false,
      clubConfirmationMethod: ClubConfirmationMethod.NotRequired,
      isCoachForClassRequired: false,
      subscriptionPlans:[],
      rooms: [],
      coaches: [],
      medias: {
        images: [],
        videos: []
      },
      isAutoMissing: false,
      billSubscriptionIdIfMissed: null,
      timeForMissing: 0
    };

    return Promise.resolve(template);
  }

  buildForm() {
    this.form = this.formBuilder.group({
      name: [this.Model.name, [NotEmpty()]],
      group: [this.Model.group, []],
      sortOrder: [this.Model.sortOrder, []],
      description: [this.Model.description, []],
      shortDescription: [this.Model.shortDescription, []],
      color: [this.Model.color, [Validators.required]],
      isPopular: [this.Model.isPopular, []],
      isVoluntaryBookingAllowed: [this.Model.isVoluntaryBookingAllowed, []],
      clubConfirmationMethod: [this.Model.clubConfirmationMethod, []],
      isCoachForClassRequired: [this.Model.isCoachForClassRequired, []],
      entityStatus: [this.Model.entityStatus, [Validators.required]],
      trainingCategories: [this.Model.trainingCategories, []],
      workingTime: [this.Model.workingTime, []],
      coaches: [this.Model.coaches, []],
      rooms: [this.Model.rooms, []],
      subscriptionPlans: [this.Model.subscriptionPlans, []],
      medias: [this.Model.medias, []],
      isAutoMissing: [this.Model.isAutoMissing, []],
      timeForMissing: [this.Model.timeForMissing, []],
      billSubscriptionIdIfMissed: [this.Model.billSubscriptionIdIfMissed, []],
      billSubscriptionIfMissed: [this.Model.billSubscriptionIfMissed, []]
    });
    if (this.Model.name !== null) {
      this.Model.name = this.Model.name.trim()
    }
    if (this.Model.group !== null) {
      this.Model.group = this.Model.group.trim()
    }
  }

  async afterModelInit() {
    if (this.Model.id) {
      delete this.Model['isClubConfirmationRequired'];

      this.service.getSubscriptions(this.Model.id)
        .then(rs => this.subscriptionPlans = rs.subscriptionPlans);

    }

    if(!this.isClubAllowedAutoMissing){
      this.Model.isAutoMissing = false;
      this.Model.timeForMissing = 0;
    }

    this.initPlans = this.Model.subscriptionPlans;

    if(this.Model.billSubscriptionIdIfMissed){
      this.clubPlans.forEach((plans, index) => {
        plans.variants.forEach((variant, vIndex) => {

          if(this.Model.billSubscriptionIdIfMissed == variant.id){
            this.Model.billSubscriptionIfMissed = index;
          }
        });
      });
    }
  }

  openImage(event: any) {
    this.mediaService.saveRedirectUrl();
    var url = this.contextService.makeContextUrl('image/' + event);
    this.router.navigate([url]);
  }

  public async finishEdit(isPublished: boolean = true, createNew?: boolean){
    this.Model.isSoldCoursesUpdate = (this.isCoursesChanged() && await this.checkIsSoldSubscriptionsInfo() &&
     await this.confirmSoldSubsUpdate() )
    super.finishEdit();
  }

  private clearSubscriptionVariantId(){

    if(this.Model.billSubscriptionIfMissed == undefined){
      this.Model.billSubscriptionIdIfMissed = "00000000000000000000000000000000";
      return;
    }

    if(this.Model.billSubscriptionIdIfMissed == "00000000000000000000000000000000" || this.Model.billSubscriptionIdIfMissed == "00000000-0000-0000-0000-000000000000")
      return;

    if(this.clubPlans[this.Model.billSubscriptionIfMissed].variants.findIndex((variant) => variant.id == this.Model.billSubscriptionIdIfMissed) == -1){
      this.Model.billSubscriptionIdIfMissed = "00000000000000000000000000000000";
    }
  }

  private checkIsSoldSubscriptionsInfo(): Promise<boolean> {
    return this.service.checkIsSoldSubscriptionsInfo(this.Model)
        .then(rs => Boolean(rs));
  }

  private isCoursesChanged(): boolean {
    return this.initPlans.length !== this.Model.subscriptionPlans.length
      || this.initPlans.some(x => !this.Model.subscriptionPlans.some(y => y.id === x.id))
      || this.Model.subscriptionPlans.some(x => !this.initPlans.some(y => y.id === x.id))
      ;
  }

  private confirmSoldSubsUpdate(): Promise<boolean> {
    return new Promise<boolean>(resolve =>
      this.alertsService.showConfirm({
        header: 'У клиентов клуба есть действующие абоненты',
        message: 'Применить изменения по доступным видам занятий к действующим абонементам?',
        callbackEsc: () => resolve(false),
        buttons: [{
          title: 'Да, применить',
          callback: () => resolve(true),
        }, {
          title: 'Не применять',
          callback: () => resolve(false),
        }]
      })
    );
  }
}
